import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María L.', 'Sofía G.', 'Valentina R.', 'Camila M.', 'Lucía P.', 'Martina S.', 'Julieta F.', 'Paula B.', 'Micaela T.', 'Florencia D.'];
const CITIES = ['Córdoba', 'Buenos Aires', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Tucumán', 'Neuquén'];
export function NotificationPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const interval = setInterval(() => {
      showNotification();
    }, 12000 + Math.random() * 5000); // Random interval between 12-17s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-74">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:bottom-8 z-50 max-w-sm" data-id="element-75">
          <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-center gap-3" data-id="element-76">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-77">
              <CheckCircle className="w-5 h-5 text-green-600" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <p className="text-sm font-medium text-gray-900" data-id="element-80">
                <span className="font-bold" data-id="element-81">{data.name}</span> de {data.city}
              </p>
              <p className="text-xs text-gray-500" data-id="element-82">
                acaba de comprar PACK INGLÉS LISTO™
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}